var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath4402(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.378,
    height: 35.378,
    viewBox: "0 0 35.378 35.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff3147;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.11,23.918a4.821,4.821,0,0,1-6.822,0L9.454,17.084a4.824,4.824,0,1,1,6.822-6.822L19.7,13.684,29.15,4.233a17.6,17.6,0,1,0,5.435,8.209Zm0,0",
    transform: "translate(0 -0.004)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath4402);
export default __webpack_public_path__ + "static/media/Path 4402.97b991815dabd433bc8ce0e0abcbf49b.svg";
export { ForwardRef as ReactComponent };